// extracted by mini-css-extract-plugin
module.exports = {"input":"bd_cV","primary":"bd_cW bd_cV","secondary":"bd_cX bd_cV","block":"bd_cY","fluid":"bd_cZ"};